import { Person } from '../Models/person';
import { Session } from '../Models/session';
import { getPerson } from '../firebase/Database/GetPerson';

export const getPeopleInSession: (
    session: Session,
) => Promise<Person[]> = async (session) => {
    let returnPeople: Person[] = [];

    if (!session.people) {
        return [];
    }

    const promises = Object.keys(session.people).map((personId) => {
        return getPerson(personId).then((res) => {
            if (res !== null) {
                return res;
            }
            return null;
        });
    });

    const results = await Promise.all(promises);

    results.forEach((person) => {
        if (person !== null) {
            returnPeople.push(person);
        }
    });

    return returnPeople;
};
